var Index = Barba.BaseView.extend({
    namespace: 'archive',
    onEnter: function() {

    },
    onEnterCompleted: function() {
        // The Transition has just finished.


    },
    onLeave: function() {
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
